import { render } from "./CotizadorResult.vue?vue&type=template&id=227e9ff4"
import script from "./CotizadorResult.vue?vue&type=script&lang=js"
export * from "./CotizadorResult.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__